<template>
  <b-card no-body>
    <b-card-header>
      <h4>{{ $t('orders.invoices') }}</h4>
    </b-card-header>

    <b-table :items="invoices" :fields="fields" responsive>
      <template #status_label="{ value, item }">
        <span class="whitespace-no-wrap">
          #{{ item.invoice_number }}
          <order-status :order="item" />
        </span>
      </template>
      <template #url="{ item }">
        <a v-if="item.url" :href="item.url" target="_blank">{{
          $t('general.download')
        }}</a>
      </template>
      <template #subtotal="{ item }">
        <order-amount :order="item" />
        <span v-if="item.total_discount" class="text-muted"
          >-{{ item.total_discount | currency(item.currency_label) }}</span
        >
      </template>
      <template #payment_method="{ item }">
        <value-payment-method :item="item" attribute="payment_method" />
      </template>
    </b-table>
  </b-card>
</template>

<script>
import OrderAmount from '../orders/OrderAmount'
import ValuePaymentMethod from '../components/values/ValuePaymentMethod'
import OrderStatus from '../orders/OrderStatus'

export default {
  name: 'BookingInvoices',

  components: { OrderStatus, OrderAmount, ValuePaymentMethod },
  props: {
    invoices: {
      type: Array,
      required: true,
    },
    showAffiliateCommission: {
      type: Boolean,
      default: false,
    },
    showPartnerCommission: {
      type: Boolean,
      default: false,
    },
    showUrl: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fields() {
      const fieldList = [
        {
          key: 'status_label',
          label: this.$t('orders.invoice'),
        },
        {
          key: 'affiliate_commission',
          formatter: this.amountFormatter,
          visible: this.showAffiliateCommission,
        },
        {
          key: 'partner_commission',
          formatter: this.amountFormatter,
          label: this.$t('orders.web_affililiate_commission'),
          visible: this.showPartnerCommission,
        },
        {
          key: 'subtotal',
          label: this.$t('orders.total'),
        },
        {
          key: 'amount_paid',
          label: this.$t('orders.amount_paid'),
          formatter: this.amountFormatter,
        },
        {
          key: 'amount_left',
          label: this.$t('orders.amount_left'),
          formatter: this.amountFormatter,
        },
        {
          key: 'payment_method',
          label: this.$t('orders.payment_method'),
        },
        {
          key: 'amount_refunded',
          label: this.$t('orders.amount_refunded'),
          formatter: this.amountFormatter,
        },
        {
          key: 'url',
          label: this.$t('orders.invoice'),
        }
      ]

      let hidden = []

      if  (! this.showUrl) {
        hidden.push('url')
      }

      this.invoices.forEach((value) => {
        if (value.affiliate_commission) {
          hidden.push('partner_commission')
        }
        if (value.partner_commission) {
          hidden.push('affiliate_commission')
        }
      })
      if (! this.showAffiliateCommission) {
        hidden.push('affiliate_commission')
      }

      if (! this.showPartnerCommission) {
        hidden.push('partner_commission')
      }

      return fieldList.filter((field) => !hidden.includes(field.key))
    },
  },
  methods: {
    amountFormatter(value, key, item) {
      return `${this.$n(value, { style: 'currency', currency: item.currency })}`
    },
  },
}
</script>
